module.exports = __webpack_public_path__ + "static/img/main-navigation-icon07.b6f706bf.svg";